import { useState, useMemo } from "react";
import { formatNumber } from "@/lib/units";
import ResultsPanel, { CalcPageHeader, Field } from "@/components/ResultsPanel";

export default function TriangleCalculator() {
  const [base, setBase] = useState("30");
  const [height, setHeight] = useState("20");

  const area = useMemo(() => 0.5 * (Number(base)||0) * (Number(height)||0), [base, height]);
  const rows = [
    ["Base", formatNumber(Number(base) || 0)],
    ["Height", formatNumber(Number(height) || 0)],
    ["Area", `${formatNumber(area)} sq units`],
  ];

  return (
    <div>
      <CalcPageHeader title="Triangle Calculator" description="Area of a triangular plot from base and perpendicular height." slug="triangle" />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-7">
          <div className="rounded-lg border border-border bg-card p-5 sm:p-6 grid grid-cols-2 gap-4">
            <Field label="Base"><input data-testid="tri-base-input" type="number" value={base} onChange={(e)=>setBase(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
            <Field label="Height"><input data-testid="tri-height-input" type="number" value={height} onChange={(e)=>setHeight(e.target.value)} className="w-full h-11 px-3 rounded-md border border-border bg-background font-mono outline-none focus:ring-2 focus:ring-primary/40" /></Field>
          </div>
        </div>
        <div className="lg:col-span-5 lg:sticky lg:top-24">
          <ResultsPanel title="Triangle" slug="triangle" highlight={{ label: "Area", value: formatNumber(area), sub: "square units" }} rows={rows} onReset={()=>{setBase("");setHeight("");}} />
        </div>
      </div>
    </div>
  );
}
